import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { styled } from '@mui/material/styles'
import { useStrapiContext } from '@context/strapiContext'
import CategoryTileCircle from '@templates/strapi-cms/content-types/CategoryTileCircle/CategoryTileCircle'
import BaseSwiper from '../../../@rtg2022/components/organisms/BaseSwiper/BaseSwiper'

const SwiperWrapper = styled('div')(({ theme }) => ({
  marginTop: '26px',
  [theme.breakpoints.down('md')]: {
    marginBottom: '16px',
  },
}))

const getVisualFilterParamsV2 = VisualFilter => {
  const windowLocationPathname = typeof window !== 'undefined' ? window.location?.pathname : null
  const selectedVisualFilterIndex = VisualFilter?.Slides?.findIndex?.(
    slide => slide?.CategoryTile?.Link?.Link?.InternalUrl === removeTrailingSlashV2(windowLocationPathname),
  )

  return selectedVisualFilterIndex
}

const generateItemKey = (VisualFilter, item) => (typeName = '') =>
  `${VisualFilter?.id}-${item.__typename}-${item?.[typeName]?.id || item?.[typeName]}`.toLowerCase()

const getSlidesV2 = VisualFilter => {
  const items = VisualFilter?.Slides || []

  return items
    .map((item, index) => {
      const getKey = generateItemKey(VisualFilter, item)
      return (
        item?.CategoryTile && (
          <CategoryTileCircle
            data={item?.CategoryTile}
            width={150}
            mobileWidth={90}
            key={getKey('CategoryTile')}
            displayFilters
            index={index}
          />
        )
      )
    })
    .filter(component => Boolean(component))
}

const removeTrailingSlashV2 = (str = '') => (str?.endsWith('/') ? str.slice(0, -1) : str)

const categoryFilterBreakpoints = {
  0: {
    slidesPerView: 3.5,
  },
  680: {
    slidesPerView: 6,
  },
  1024: {
    slidesPerView: 6,
  },
}

const VisualFilter = ({ data }) => {
  const VisualFilterData = data?.VisualFilter || data
  const { testId } = VisualFilterData
  const selectedVisualFilterIndex = getVisualFilterParamsV2(VisualFilterData)
  const slides = getSlidesV2(VisualFilterData)

  return (
    <SwiperWrapper>
      <BaseSwiper
        title="Heading"
        slides={slides}
        spaceBetween={32}
        spaceBetweenMobile={15}
        dataTestId={testId}
        activeIndex={selectedVisualFilterIndex}
        breakpoints={categoryFilterBreakpoints}
        isDisplayFilter
        centered
        isVisualFilter
        hideScrollbarMobile
      />
    </SwiperWrapper>
  )
}

export default VisualFilter

VisualFilter.propTypes = {
  data: PropTypes.object.isRequired,
}

export const VisualFilterFragment = graphql`
  fragment VisualFilterFragment on StrapiVisualFilter {
    testId
    Slides {
      CategoryTile {
        ...StrapiCategoryTileFragment
      }
    }
  }
`
